import '../../assets/scss/containers.scss';

const Workouts = () => {
  return (
    <div className="fiterr-app-section">
      <div className="fiterr-app-inner-wrapper">
        <div className="fiterr-app-page-container">
          <div className="dashboard-welcome-wrapper">
            <div className="dashboard-welcome-message">
              Workouts
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Workouts;